import { render, staticRenderFns } from "./save-terminal-block-dialog.component.vue?vue&type=template&id=479aaae4&scoped=true"
import script from "./save-terminal-block-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-terminal-block-dialog.component.ts?vue&type=script&lang=ts&external"
import style0 from "./save-terminal-block-dialog.component.vue?vue&type=style&index=0&id=479aaae4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479aaae4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('479aaae4')) {
      api.createRecord('479aaae4', component.options)
    } else {
      api.reload('479aaae4', component.options)
    }
    module.hot.accept("./save-terminal-block-dialog.component.vue?vue&type=template&id=479aaae4&scoped=true", function () {
      api.rerender('479aaae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/save-terminal-block-dialog/save-terminal-block-dialog.component.vue"
export default component.exports